import { render, staticRenderFns } from "./StudySurveyDataManage.vue?vue&type=template&id=0910d5da&scoped=true"
import script from "./StudySurveyDataManage.vue?vue&type=script&lang=js"
export * from "./StudySurveyDataManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0910d5da",
  null
  
)

export default component.exports